var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { hideVisually } from 'polished';
import { Box } from 'rebass';
import { Icon } from '../';
var visuallyHidden = hideVisually();
export default function Checkbox(_a) {
    var checked = _a.checked, disabled = _a.disabled, fontSize = _a.fontSize, _b = _a.icon, icon = _b === void 0 ? 'check' : _b, m = _a.m, mb = _a.mb, ml = _a.ml, mr = _a.mr, mt = _a.mt, mx = _a.mx, my = _a.my, onChange = _a.onChange, partial = _a.partial, ref = _a.ref, _c = _a.variant, variant = _c === void 0 ? 'default' : _c, width = _a.width, props = __rest(_a, ["checked", "disabled", "fontSize", "icon", "m", "mb", "ml", "mr", "mt", "mx", "my", "onChange", "partial", "ref", "variant", "width"]);
    var click = React.useCallback(function (e) {
        if (e.shiftKey)
            onChange(e);
    }, [onChange]);
    var margins = Object.fromEntries(Object.entries({ m: m, mb: mb, ml: ml, mr: mr, mt: mt, mx: mx, my: my }).filter(function (_a) {
        var k = _a[0], v = _a[1];
        return v !== undefined;
    }));
    var i = icon;
    if (variant == 'radio') {
        i = 'circle';
    }
    else if (partial) {
        i = 'minus';
    }
    var iconSize = fontSize || (variant == 'radio' ? '10px' : '6px');
    return (React.createElement(Box, { sx: __assign(__assign(__assign({}, margins), (width !== undefined ? { width: width, height: width } : {})), { position: 'relative', zIndex: 0 }) },
        React.createElement(Box, { as: "input", type: "checkbox", sx: visuallyHidden, checked: checked, onChange: onChange, disabled: disabled }),
        React.createElement(Box, __assign({ variant: "checkbox." + variant, fontSize: iconSize, onClick: click }, props, { sx: __assign({ userSelect: 'none', bg: 'neutral_0', border: '1px solid', borderColor: 'neutral_4', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', top: 0, transition: 'all 150ms', width: width, height: width, cursor: 'pointer', '& > svg': {
                    visibility: 'hidden',
                }, 'input:checked + & > svg': {
                    visibility: 'visible',
                } }, (disabled ? { pointerEvents: 'none' } : {})) }),
            React.createElement(Icon, { icon: ['fas', i] }))));
}
Checkbox.defaultProps = {
    width: '16px',
};
